<template>
  <div class="form_wrapper">
    <el-form :rules="formRules" :model="formObj" ref="entryForm">
      <el-form-item label="姓名" class="entry-form-item" prop="name">
        <el-input v-model.trim="formObj.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="手机号" class="entry-form-item" prop="phone">
        <el-input v-model.trim="formObj.phone" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="所在学校" class="entry-form-item" prop="school">
        <el-input v-model.trim="formObj.school" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="院系" class="entry-form-item" prop="department">
        <el-input v-model.trim="formObj.department" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="学号" class="entry-form-item" prop="student_number">
        <el-input v-model.trim="formObj.student_number" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="报名理由" style="clear:both;" prop="application_reason">
        <el-input type="textarea" v-model="formObj.application_reason"></el-input>
      </el-form-item>
      <div class="submit_wrapper">
        <el-button type="primary" @click="submitForm('entryForm', apply)">确认报名</el-button>
        <el-button @click="closeDialog()">取消</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
import { applyCompetitionsCheck } from "@/api/course";
import qs from "qs";
export default {
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入你的手机号"));
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    return {
      formObj: {
        name: "", //姓名
        phone: "", //手机号
        school: "", //学校
        department: "", //院系
        student_number: "", //学号
        application_reason: "" //报名理由
      },
      formRules: {
        name: [{ required: true, message: "请输入你的姓名", trigger: "blur" }],
        phone: [{ required: true, validator: checkPhone, trigger: "blur" }],
        school: [
          { required: true, message: "请输入你的学校", trigger: "blur" }
        ],
        department: [
          { required: true, message: "请输入你的院系", trigger: "blur" }
        ],
        student_number: [
          { required: true, message: "请输入你的学号", trigger: "blur" }
        ],
        application_reason: [
          { max: 200, message: "报名理由在200位字符以内", trigger: "change" }
        ]
      }
    };
  },
  props: {
    competitionId: {
      type: Number,
      required: true
    }
  },
  mounted() { },
  methods: {
    clearFields: function () {
      this.$refs.entryForm.resetFields();
    },
    closeDialog() {
      this.$emit("close");
    },
    submitForm: function (formName, nextFunction) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          nextFunction();
        } else {
          return false;
        }
      });
    },
    apply() {
      var that = this;
      applyCompetitionsCheck(
        this.competitionId,
        qs.stringify(this.formObj)
      ).then(response => {
        if (response.code == 200) {
          this.$message.success({
            message: "报名成功，请等待审核"
          });
          that.clearFields;
          that.$emit("fetchData");
          that.$emit("close");
        }
      });
    }
  }
};
</script>
<style scoped>
.form_wrapper {
  width: 100%;
}
.entry-form-item {
  width: 320px;
  float: left;
}
.form_wrapper >>> .el-form-item .el-form-item__content {
  width: calc(100% - 90px);
  display: flex;
}
.form_wrapper >>> .el-form-item .el-form-item__label {
  width: 90px;
}
.form_wrapper >>> .el-form-item .el-textarea {
  width: calc(100% - 20px);
}
.submit_wrapper {
  text-align: center;
}
</style>
